import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Quotation: RouteRecordRaw = {
  name: "报价单管理",
  path: "/quotation",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/quotation"
  },
  children: [
    {
      name: "客户报价单列表",
      path: "customer-quotation-list",
      meta: {
        key: "/quotation/customer-quotation-list",
        keepAlive: true
      },
      component: () =>
        import("@/views/Quotation/CustomerQuotationList/index.vue").catch(
          onError
        )
    },
    {
      name: "客户报价单变更日志",
      path: "customer-quotation-log",
      meta: {
        key: "/quotation/customer-quotation-log"
      },
      component: () =>
        import("@/views/Quotation/CustomerQuotationLog/index.vue").catch(
          onError
        )
    },
    {
      name: "客户报价单变更记录",
      path: "quotation-log",
      meta: {
        key: "/quotation/quotation-log"
      },
      component: () =>
        import("@/views/Quotation/QuotationLog/index.vue").catch(onError)
    },
    {
      name: "媒体报价单管理",
      path: "media-quotation-list",
      meta: {
        key: "/quotation/media-quotation-list",
        keepAlive: true
      },
      component: () =>
        import("@/views/Quotation/MediaQuotationList/index.vue").catch(onError)
    },
    {
      name: "补充Offer信息",
      path: "add-offer-info",
      meta: {
        key: "/quotation/add-offer-info",
        keepAlive: false
      },
      component: () =>
        import("@/views/Quotation/AddOfferInfo/index.vue").catch(onError)
    }
  ]
};

export default Quotation;
